
export const aliasMap: Record<string, string> = {
  'userremove1': 'userremove',
  'userremove2': 'userremove',
  'deleteuser': 'userremove',
  'userinactive': 'userremove',
  'headeractions': 'action',
  'actionworkflow': 'action',
  'applications': 'action',
  'application':'selectapplication',
  'flowh':'attributemap',
  'flowmaphand': 'handtool',
  'sendprompt': 'send',
  'while':'whileloop',
  'datatypeexpression': 'js',
  'flowmapredo':'arrow',
  'continuous':'frequency',
  'every':'frequency',
  'document':'documentnew',
  'revokationcycle':'revocationcycle',
  'revocationcycle': 'revocationcycle',
  'form':'documentnew',
  'flowmapaquera':'aquera',
  'block02': 'block',
  'componentblock': 'block',
  'flowmapblock': 'block',
  'calendar01': 'calendar',
  'playcircle': 'play',
  'setting': 'settings',
  'settings1': 'settings',
  'trash': 'delete',
  'trash01': 'delete',
  'trashnofill': 'delete',
  'trash03': 'delete',
  'download01': 'download',
  'download02': 'download',
  'datatypepersistentvariable': 'persistentvariable',
  'leftarrow': 'arrowleft',
  'prev':'arrowleft',
  'rightarrow': 'arrowright',
  'next':'arrowright',
  'searchlg': 'search',
  'info2': 'info',
  'infoicon1': 'info',
  'infocircle': 'info',
  'dropdown': 'options',
  'flowmapellipsis': 'options',
  'dotsvertical': 'options',
  'bellicon':'notification',
  'stopcircle': 'stop',
  'agents': 'agent',
  'event': 'trigger',
  'editpencil': 'pencil',
  'pen': 'pencil',
  'editwrite': 'pencil',
  'shape': 'pencil',
  'edit01': 'pencil',
  'updateuser': 'pencil',
  'edit1': 'pencil',
  'notscheduled': 'error',
  'not': 'error',
  'flowmapcancel': 'error',
  'cancel': 'error',
  'xcircle': 'error',
  'undo1': 'undo',
  'privilage': 'privilege',
  'privilegeobject': 'privilege',
  'bell': 'mute',
  'barchartsquare03': 'barchartsquare02',
  'helpcircle': 'helpandsupport',
  'help1': 'helpandsupport',
  'caution': 'helpandsupport',
  'smalltick': 'tick',
  'check': 'tick',
  'userselection': 'useractive',
  'selectuser': 'useractive',
  'usergroup': 'group',
  'multipleuser': 'group',
  'usersquare': 'user',
  'useranalysisicon': 'user',
  'usercircle': 'user',
  'user03': 'user',
  'personaldetails': 'user',
  'user01': 'user',
  'workfloworchestration': 'flowmaporchestration',
  'workflow01': 'flowmap',
  'workflowsolid': 'flowmap',
  'section02': 'section',
  'flowmapsection': 'section',
  'workflowsection': 'section',
  'variablenew1': 'variablenew',
  'rolemanager': 'role',
  'manageduser': 'manage',
  'folder01': 'folder',
  'headerfunctions': 'script',
  'users01': 'users',
  'users02': 'users',
  'ouanalysisicon': 'users',
  'draglist': 'drag',
  'flowmapdrag': 'drag',
  'itemplaceholder': 'drag',
  'placeholderwf': 'drag',
  'anomaly': 'thumbsdown',
  'noanomaly': 'thumbsup',
  'approve': 'thumbsup',
  'enabled': 'enable',
  'themes': 'color',
  'palette': 'color',
  'expand1': 'sort',
  'chevronselectorvertical': 'sort',
  'default1': 'default',
  'custom': 'default',
  'basic': 'default',
  'droparrow': 'arrowdown',
  'nextdown': 'arrowdown',
  'chevrondown': 'arrowdown',
  'downarrow': 'arrowdown',
  'plusicon': 'pluscircle',
  'flow01': 'condition',
  'table1': 'logs',
  'flowmaptext': 'text',
  'workflowtext': 'text',
  'layersthree01': 'layersthree02',
  'uparrow': 'chevronup',
  'prevup': 'chevronup',
  'headervariable': 'variable',
  'datatypevariable': 'variable',
  'variablelocal1': 'variablelocal',
  'refreshcw03': 'refresh',
  'if':'ifelse',
};
